import { useMutation, useQueryClient } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import { apiUrl } from "../../utils/apiUrl";

interface UploadPastOrdersResponse {
  message: string;
  processed_orders: number;
  existing_orders: number;
  errors: string[];
}

export default () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  return useMutation<UploadPastOrdersResponse, Error, { file: File; organizationId: string }>(
    async ({ file, organizationId }) => {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(
        apiUrl(`/api/order/organization/${organizationId}/upload-past-orders`),
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${await getAccessTokenSilently()}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to upload past orders");
      }

      return response.json();
    },
    {
      onSuccess: (data, variables) => {
        // Invalidate and refetch orders for the organization
        queryClient.invalidateQueries(`admin_orders_${variables.organizationId}`);
      },
    }
  );
};
